export default __webpack_public_path__ + "static/media/spaceman_and_planet.27f623b3.png";